import { findCenter, findProduct, type Catalog } from './catalog.js'
import { F } from './fields.js'
import type { OrderForm } from './order.js'

export interface FieldError { field: string; message: string }

export const MAX_NAME_LENGTH = 200
export const MAX_MEMBER_NUMBER_LENGTH = 50

// char.IsControl: Unicode category Cc
const CONTROL = /[\u0000-\u001f\u007f-\u009f]/

/** The four checks, same order and wording as OrderValidator.cs. [] = valid. Missing (undefined) values count as null. */
export function validateOrder(form: OrderForm, catalog: Catalog, todayEt: string): FieldError[] {
  const e: FieldError[] = []
  const add = (field: string, message: string): void => { e.push({ field, message }) }
  const f = form

  // Typed text goes into the email and the order record; a line break could forge email lines.
  // Checked after trimming, which is what gets saved.
  const required = (value: string | null | undefined, max: number, field: string, label: string): void => {
    if (typeof value !== 'string' || value.trim() === '') add(field, `${label} is required.`)
    else if (value.trim().length > max) add(field, `${label} must be ${max} characters or fewer.`)
    else if (CONTROL.test(value.trim())) add(field, `${label} can't contain line breaks or control characters.`)
  }

  // 1. Order date: required, and not a day that hasn't happened yet
  if (f.order_date == null) add(F.orderDate, 'Order date is required.')
  else if (f.order_date > todayEt) add(F.orderDate, "Order date can't be in the future.")

  // 2. Participant
  required(f.participant_name, MAX_NAME_LENGTH, F.participantName, 'Participant name')
  required(f.member_number, MAX_MEMBER_NUMBER_LENGTH, F.memberNumber, 'Member number')

  // 3. Center
  if (typeof f.center_id !== 'string' || f.center_id.trim() === '') add(F.center, 'Choose a center.')
  else if (!findCenter(catalog, f.center_id)) add(F.center, 'Choose a center from the list.')

  // 4. Exactly one hearing aid, from the catalog
  if (typeof f.product_id !== 'string' || f.product_id.trim() === '') add(F.product, 'Choose a hearing aid.')
  else if (!findProduct(catalog, f.product_id)) add(F.product, 'Choose a hearing aid from the list.')

  return e
}
